module.exports = __webpack_public_path__ + "static/media/cloneWiki.d668512e.PNG";